// src/pages/admin/CoursesList.js
import React from 'react';
import { Card, List, Avatar, Button } from 'antd';
import { BookOutlined } from '@ant-design/icons';

const CoursesList = ({ courses, navigate }) => (
  <Card title="Recent Courses" bordered={false} style={{ marginTop: 16 }}>
    <List
      itemLayout={window.innerWidth < 768 ? 'vertical' : 'horizontal'}
      dataSource={courses.slice(0, 5)}
      renderItem={(item) => (
        <List.Item
          actions={[
            <Button type="link" onClick={() => navigate(`/admin/student/courses/edit/${item.id}`)}>Edit</Button>,
          ]}
        >
          <List.Item.Meta
            avatar={<Avatar icon={<BookOutlined />} />}
            title={item.title}
            description={`Status: ${item.status} | Enrollments: ${item.enrollments}`}
          />
        </List.Item>
      )}
    />
  </Card>
);

export default CoursesList;